import { TextAreaWUT } from '@wix/form-fields/viewer-wut';

export default TextAreaWUT;
